interface CountdownOptions {
  targetDate: string;
  countSeconds?: boolean;
}

const countdowns: NodeListOf<HTMLElement> = document.querySelectorAll('[data-countdown]');

const _second: number = 1000;
const _minute: number = _second * 60;
const _hour: number = _minute * 60;
const _day: number = _hour * 24;

document.addEventListener('DOMContentLoaded', (): void => {
  countdowns.forEach((element: HTMLElement): void => {
    initCountDown(element);
  });
});

function initCountDown(element: HTMLElement): void {
  const options: CountdownOptions = JSON.parse(element.dataset.countdown || '{}');
  compileTime(element, options);

  const interval: number = window.setInterval((): void => {
    if (!compileTime(element, options)) {
      window.clearInterval(interval);
      //window.location.reload();
    }
  }, options.countSeconds ? _second : _minute);
}

function compileTime(element: HTMLElement, options: CountdownOptions): boolean {
  const targetDate: Date = new Date(options.targetDate);
  const now: Date = new Date();
  const distance: number = targetDate.getTime() - now.getTime();

  if (distance < 0) {
    return false;
  }

  const days: number = Math.floor(distance / _day);
  let daysString: string = days === 1 ? 'giorno' : 'giorni';
  const hours: number = Math.floor((distance % _day) / _hour);
  let hoursString: string = hours === 1 ? 'ora' : 'ore';
  const minutes: number = Math.floor((distance % _hour) / _minute);
  let minutesString: string = minutes === 1 ? 'minuto' : 'minuti';
  const seconds: number = Math.floor((distance % _minute) / _second);
  let secondsString: string = seconds === 1 ? 'secondo' : 'secondi';

  daysString = days > 0 ? `${days} ${daysString}` : '';
  let separator: string = daysString.length > 0 ? ' ' : '';
  hoursString = hours > 0 ? `${separator}${hours} ${hoursString}` : `${separator}`;
  separator = hoursString.length > 0 ? ' ' : '';

  if (options.countSeconds) {
    minutesString = minutes > 0 ? `${separator}${minutes} ${minutesString}` : `${separator}`;
    separator = minutesString.length > 0 ? ' e ' : '';
    secondsString = seconds > 0 ? `${separator}${seconds} ${secondsString}` : `${separator}`;

    element.innerHTML = `${daysString}${hoursString}${minutesString}${secondsString}`;
  } else {
    separator = hoursString.length > 0 ? ' e ' : '';
    minutesString = minutes > 0 ? `${separator}${minutes} ${minutesString}` : `${separator}`;

    element.innerHTML = `${daysString}${hoursString}${minutesString}`;
  }

  return true;
}
